import { useEffect, useState } from "react";
import { DialogBase } from "components/dialog"
import {
	Alert,
	Box,
	List,
	ListItem,
	ListItemButton,
	Slide,
	Stack
} from "@mui/material"

import { NotificationResult, ListOpenNotification } from "interface/notification"

import { Loading } from "components/controls/loading"
import { ErrorInfo } from "components/controls/errorInfo"

import { NotificationHeadline } from "../components/headLine"
import { NotificationDetail } from "../components/detail"

type OpenNotificationDialogProps = {
	domain: string
	onClose: () => void
}
export const OpenNotificationDialog = ({
	domain,
	onClose
}: OpenNotificationDialogProps) => {
	const [tenantResourceError, setTenantResourceError] = useState<Error | undefined>()
	const [notifications, setNotifications] = useState<NotificationResult[] | null>(null)
	const [openedNotification, setOpenedNotification] = useState<NotificationResult | null>(null)

  useEffect(() => {
    ListOpenNotification(domain)
      .catch(reason => setTenantResourceError(reason))
      .then(response => setNotifications(response?.list ?? []))
  }, [domain])

	if (!tenantResourceError && notifications === null) {
		return <Loading/>
	}
	return (
		<DialogBase
			open
			fullWidth
			maxWidth="sm"
			contentProps={{
				sx: {
					paddingX: 0,
          height: '60vh'
				}
			}}
			title={`お知らせ（${notifications?.length}件）`}
			body={
				<Stack direction="column">
					{tenantResourceError && <ErrorInfo error={tenantResourceError}/>}
					{notifications?.length === 0 ? (
						<Alert severity="info">有効なお知らせがありません</Alert>
					) : notifications ? (
						<Box sx={{ position: "relative" }} flexGrow={1}>
							<Slide
								key="notification_list"
								direction="right"
								in={openedNotification === null}
								appear={false}
							>
								<List>
									{notifications.map(notification =>
										(notification.description && notification.description.length > 0) ? (
											<ListItemButton
												key={`notification_${notification.notificationId}`}
												onClick={() => setOpenedNotification(notification)}
												disableGutters
												disableRipple
												sx={{
													padding: 0
												}}
											>
												<ListItem>
													<NotificationHeadline
														domain={domain}
														notification={notification}
													/>
												</ListItem>
											</ListItemButton>
										) : (
											<ListItem key={`notification_${notification.notificationId}`}>
												<NotificationHeadline
													domain={domain} 
													notification={notification}
													link={notification.url}
												/>
											</ListItem>
										)
									)}
								</List>
							</Slide>

							{openedNotification && (
								<Slide
									key="notification_detail"
									direction="left"
									in
									style={{
										position: "absolute",
										zIndex: 1,
										top: 0,
										left: 0,
										width: "100%"
									}}
								>
									<NotificationDetail domain={domain} notification={openedNotification}/>
								</Slide>
							)}
						</Box>

					) : <></>}
				</Stack>
			}
      action={{ onClose }}
			onClose={onClose}
			onBack={openedNotification !== null ? () => setOpenedNotification(null) : undefined}
		/>
	)
}